import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import s from './Button.scss';

const Button = ({ variantClasses = [], text, type, location, href, children = null, disabled = false, clickEventHandler = () => {}, mouseEnterEventHandler, mouseLeaveEventHandler, style = null }) => {
	let classes = [s.button];
	if (variantClasses) classes = [...classes, ...(Array.isArray(variantClasses) ? variantClasses.filter((c) => !!c).map((c) => s[c]) : [s[variantClasses.toString()]])];
	if (disabled) classes.push(s.button__disabled);
	const innerContent = text || children;

	if (type === 'link' && !location) return <span className={classes.join(' ')} style={style}>{ innerContent }</span> || null;

	const externalLink = /^(https?|mailto|tel)/.test(location);
	const anchorLink = /^#/.test(location);

	if (type === 'a' || (type === 'link' && externalLink) || (type === 'link' && anchorLink)) {
		const attrs = {};
		if (href) attrs.href = href;
		return <a className={classes.join(' ')} {...attrs} onClick={clickEventHandler} style={style}>{ innerContent }</a>; // eslint-disable-line
	}
	if (type === 'link') {
		return <Link className={classes.join(' ')} to={location} style={style}>{ innerContent }</Link>;
	}
	return <button className={classes.join(' ')} disabled={disabled} type={type} onClick={clickEventHandler} onMouseEnter={mouseEnterEventHandler} onMouseLeave={mouseLeaveEventHandler} style={style}>{ innerContent }</button>; // eslint-disable-line react/button-has-type
};

export default hot(module)(Button);
